import { Component } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ILoginCommand, LoginCommand, TokensClient } from '../../shared/model/fss.api';
import { ControlsOf } from '../../shared/forms/forms-common';
import { FieldComponent } from '../../shared/ui/field/field';
import { EmailInputComponent } from '../../shared/components/email-input/email-input';
import { FormControlPipe } from '../../shared/pipes/form-control.pipe';
import { LoaderService } from '../../shared/components/loader/loader.service';
import { AuthService } from '../../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent, ButtonSize } from '../../shared/ui/button/button';
import { TextInput } from '../../shared/ui/text-input/text-input';
import { Lock03 } from '../../shared/icons/lock-03/lock-03';
import { LocationService } from '../../shared/services/location.service';
import { UserService } from '../../shared/services/user.service';
import { getRoleHomeUrl } from '../../shared/services/root-redirect.guard';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
  standalone: true,
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    FieldComponent,
    EmailInputComponent,
    FormControlPipe,
    ButtonComponent,
    TextInput,
    Lock03,
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  currentYear = new Date().getFullYear();

  form: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _loaderService: LoaderService,
    private _client: TokensClient,
    private _authService: AuthService,
    private _router: Router,
    private _route: ActivatedRoute,
    public location: LocationService,
    private _userService: UserService,
    private _notificationService: NotificationService,
  ) {
    this.form = this._fb.group<ControlsOf<ILoginCommand>>({
      email: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      password: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });
  }

  handleLogin() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    this._loaderService.setLoadingText = 'Provera korisnika...';
    this._loaderService.setShowLoader = true;
    this.login().then((res) => {
      this._authService.setTokens(res.result.value!.token!, res.result.value!.refreshToken!);
      this._authService.startSignalR();
      this._notificationService.loadUnreadCount();

      const returnUrl = this._route.snapshot.queryParams['returnUrl'];
      if (returnUrl && returnUrl !== '/') {
        this._router.navigateByUrl(returnUrl);
        return;
      }

      this._router.navigateByUrl(getRoleHomeUrl(this._userService.getUserData.role));
    });
  }

  private async login() {
    return await firstValueFrom(this._client.getToken(this.form.value as LoginCommand));
  }

  protected readonly ButtonSize = ButtonSize;
}
